import { Link } from "react-router-dom";
import type { Article } from "@/types/melon";

type HeatRankingProps = {
  articles: Article[];
};

export default function HeatRanking({ articles }: HeatRankingProps) {
  const ranked = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h2 className="font-heading text-sm font-semibold text-foreground-950">热度榜</h2>
        <span className="flex items-center gap-1 text-xs text-accent-700">
          <i className="ri-fire-line"></i>
          实时
        </span>
      </div>
      <ol className="mt-4 space-y-4">
        {ranked.map((article, index) => (
          <li key={article.slug} className="flex gap-3">
            <span
              className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                index < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
              }`}
            >
              {index + 1}
            </span>
            <div className="min-w-0">
              <Link
                to={`/article/${article.slug}`}
                className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 transition-colors hover:text-primary-700"
              >
                {article.title}
              </Link>
              <p className="mt-1 text-xs text-foreground-500">
                {article.topicName} · 热度 {article.heat}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}